import * as React from 'react';
import { X } from 'lucide-react';

import { cn } from '@ais-ui/utils';
import { Input } from './Input';

interface SearchInputProps extends React.ComponentProps<'input'> {
  onClear?: () => void;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, onClear, value, ...props }, ref) => {
    const showClear = onClear && value !== undefined && value !== '';

    return (
      <div className="relative w-full">
        <Input
          ref={ref}
          className={cn(showClear && 'pr-8', className)}
          value={value}
          {...props}
        />
        {showClear && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-sm p-0.5 text-muted-foreground hover:text-foreground"
            aria-label="Clear search"
          >
            <X className="size-4" />
          </button>
        )}
      </div>
    );
  },
);
SearchInput.displayName = 'SearchInput';

export { SearchInput };
export type { SearchInputProps };
